import type { JobWidgetSchemaPatched } from './types';

export const defaultWidgets: JobWidgetSchemaPatched[] = [
  {
    id: '9c947630-3934-11eb-a6db-470c8e15a324',
    options: {
      columns: [
        'title',
        'type',
        'progress_processed',
        'status',
        'date_created',
      ],
      filters: {
        my_jobs: true,
        object_type: [],
        status: [],
        type: [],
      },
      limit: 25,
      sort: [
        {
          name: 'date_created',
          order: 'desc',
        },
      ],
    },
    title: 'My Jobs',
    type: 'JOBS_LIST',
  },
  {
    id: 'bab0c310-3495-11eb-b17d-6b8287ba3c3e',
    options: {
      columns: [
        'title',
        'type',
        'progress_processed',
        'status',
        'date_modified',
      ],
      filters: {
        my_jobs: false,
        object_type: [],
        status: ['FAILED'],
        type: [],
      },
      limit: 25,
      sort: [
        {
          name: 'date_modified',
          order: 'desc',
        },
      ],
    },
    title: 'Failed Jobs',
    type: 'JOBS_LIST',
  },
  {
    id: '817e0330-2f15-11eb-8c74-17a4b2a95636',
    options: {
      columns: ['title', 'progress_processed', 'date_created', 'priority'],
      filters: {
        date_created: '',
        my_jobs: false,
        object_type: [],
        status: ['WAITING'],
        type: ['TRANSCODE'],
      },
      limit: 25,
      sort: [
        {
          name: 'priority',
          order: 'desc',
        },
        {
          name: 'date_created',
          order: 'desc',
        },
      ],
    },
    title: 'Transcode Queue',
    type: 'JOBS_STATS_LIST',
  },
  {
    id: '8d778b40-309e-11eb-b058-fd8a7c259569',
    options: {
      columns: ['title', 'progress_processed', 'date_created'],
      filters: {
        my_jobs: false,
        object_type: [],
        status: ['STARTED'],
        type: ['TRANSCODE'],
      },
      limit: 25,
      sort: [
        {
          name: 'date_created',
          order: 'desc',
        },
      ],
    },
    title: 'Ongoing Transcodes',
    type: 'JOBS_LIST',
  },
];
